import React from 'react';

interface SectionHeadingProps {
  icon: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  icon,
  title,
  description,
  actions,
}) => (
  <div className="mb-4 flex items-start justify-between gap-4">
    <div className="flex items-start gap-3">
      <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-lg dark:bg-blue-900/30">
        {icon}
      </span>
      <div className="min-w-0">
        <h3 className="text-[15px] font-semibold text-title-page-color-100 dark:text-gray-100">
          {title}
        </h3>
        {description && (
          <p className="mt-0.5 text-xs text-title-page-color-300 dark:text-gray-400">
            {description}
          </p>
        )}
      </div>
    </div>
    {actions && <div className="shrink-0">{actions}</div>}
  </div>
);
